import { render, staticRenderFns } from "./create-section.component.html?vue&type=template&id=034816c5&scoped=true&"
import script from "./create-section.component.ts?vue&type=script&lang=ts&"
export * from "./create-section.component.ts?vue&type=script&lang=ts&"
import style0 from "./create-section.component.scss?vue&type=style&index=0&id=034816c5&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034816c5",
  null
  
)

export default component.exports